/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]{position:relative;display:table;border-collapse:separate}.input-group-addon[_ngcontent-%COMP%]{border-color:#fff!important;background:inherit}"];
export { styles as styles };
